import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from '@/plugins/vuetify'

import ApolloClient from 'apollo-boost'
import VueApollo from 'vue-apollo'
import Moment from 'vue-moment'

import FormAlert from './components/Shared/FormAlert'
import Router from 'vue-router';

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
};

Vue.use(Router);

Vue.component('form-alert', FormAlert)

Vue.use(VueApollo)
Vue.use(Moment)

export const defaultClient = new ApolloClient({
  //uri: 'https://cookation.herokuapp.com',
  //uri: 'http://localhost:4000/',
  uri: 'https://cook.equization.com/',
  //Include auth token with requests to backend
  fetchOptions: {
    credentials: 'include'
  },
  request: operation => {
    // if no token in localstorage, add it
    if (!localStorage.token) {
      localStorage.setItem('token', '')
    }
    // operation adds the token to an authorization header, which is sent to backend
    operation.setContext({
      headers: {
        authorization: localStorage.getItem('token')
      }
    })
  },
  onError: ({ graphQLErrors, networkError}) => {
    
    if(networkError) {
      console.log('[networkError]', networkError)
    }
    
    if(graphQLErrors) {
      
      for (let err of graphQLErrors) {

        if(err.name === "AuthenticationError") {
          // Set auth error is state (to show is snackbar)
          
          store.commit('setAuthError', err)
          //Signout user (to clear token)
          store.dispatch('signout')
        } 
      }
    }
  }
})

const apolloProvider = new VueApollo({ defaultClient})

Vue.config.productionTip = false

new Vue({
  apolloProvider,
  router,
  store,
  vuetify,
  render: h => h(App),
  created() {
    // excute getCurrentUser
    this.$store.dispatch('getCurrentUser')
    // this.$store.dispatch('getCategories')
    // this.$store.dispatch('getCountries')
  }
}).$mount('#app')
